import store from "@/store/store";

import { isDeliveryAvailable } from "@/plugins/subscriptions_helper";

export const hasToken = async (to, from, next) => {
  const getIsToken = store.getters.getIsToken;
  if (!getIsToken) {
    const name = to.name;
    const query = to.query;
    const params = to.params;
    store.commit("PATH_TEMPORAL", { name, params, query });
    next({ name: "loginSubscriptions", replace: true });
  } else {
    next();
  }
};

export const isLogin = async (to, from, next) => {
  const getIsToken = store.getters.getIsToken;
  if (getIsToken) {
    next({ name: "subscriptionWelcome" });
  } else {
    next();
  }
};

export const isSubscription = async (to, from, next) => {
  if (!store.getters.getSubscription) {
    await store.dispatch("action_getAllSubscriptions", { commerceId: 3 });
    if (!store.getters.getSubscription) {
      next({ name: "missingSubscription" });
    } else {
      next();
    }
  } else {
    next();
  }
};

export const missingSubscription = async (to, from, next) => {
  if (!store.getters.getSubscription) {
    await store.dispatch("action_getAllSubscriptions", { commerceId: 3 });
    if (store.getters.getSubscription) {
      next({ name: "subscriptionDashboard" });
    } else {
      next();
    }
  } else {
    next({ name: "subscriptionDashboard" });
  }
};

export const canEditNextOrder = (to, from, next) => {
  const subscription = store.getters.getSubscription;
  if (!isDeliveryAvailable(subscription)) next({ name: "subscriptionOrdersHome" });
  else next();
};
